module.exports = "<mat-icon title=\"My Calls Today\" (click)=\"onClick()\">timeline</mat-icon>\r\n"